/* ═══════════════════════════════════════════════════════════════════════
   FizzyIQ — FAQ video row. Mirrors the testimonials video behavior:
     • Lazy-attach video src + autoplay muted when the card nears the
       viewport (no video bytes on first paint).
     • Click the card (or its speaker button) to unmute → restart from 0.
     • Only one video audible at a time — unmuting one mutes the others
       in the SAME section.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__fizzyFaqVideosBooted) return;
  window.__fizzyFaqVideosBooted = true;

  function bootCard(card) {
    var v = card.querySelector('.ffv-video');
    var btn = card.querySelector('.ffv-mute');
    if (!v) return;

    /* Scope "mute the others" to the row — works whether the cards live
       in the standalone .ffv section OR embedded in the FAQ page (where
       there's no .ffv wrapper, only .ffv-row). */
    var section = card.closest('.ffv-row') || document;

    var srcAttached = false;
    function attachSrc() {
      if (srcAttached) return;
      var url = v.getAttribute('data-src');
      if (!url) return;
      srcAttached = true;
      v.setAttribute('src', url);
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { attachSrc(); io.disconnect(); }
        });
      }, { rootMargin: '300px 0px' });
      io.observe(card);
    } else {
      attachSrc();
    }

    function syncMuteState() {
      var muted = v.muted;
      card.classList.toggle('is-muted', muted);
      /* Show native scrubbing controls while the user is actively watching
         (unmuted); hide them on the muted autoplay loop. */
      v.controls = !muted;
      if (btn) btn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
    }
    syncMuteState();
    /* Keep card state in sync if the viewer uses the native controls' own
       mute/volume. */
    v.addEventListener('volumechange', syncMuteState);

    function toggleMute() {
      attachSrc();
      var wasMuted = v.muted;
      v.muted = !v.muted;
      syncMuteState();
      if (wasMuted && !v.muted) {
        try { v.currentTime = 0; } catch (err) {}
      }
      if (v.paused) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      /* Becoming audible — mute every other video in this section. */
      if (wasMuted && !v.muted && section) {
        section.querySelectorAll('.ffv-card.has-video').forEach(function (other) {
          if (other === card) return;
          var ov = other.querySelector('.ffv-video');
          if (!ov) return;
          ov.muted = true;
          other.classList.add('is-muted');
          var oBtn = other.querySelector('.ffv-mute');
          if (oBtn) oBtn.setAttribute('aria-label', 'Unmute video');
        });
      }
    }

    if (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleMute();
      });
    }
    card.addEventListener('click', function (e) {
      if (e.target.closest('.ffv-mute')) return;
      if (e.target.closest('[data-ffv-info-open]')) return;
      if (e.target.closest('[data-ffv-info-modal]')) return;
      /* Once unmuted, native controls are showing — let them handle clicks
         (scrub / play-pause) instead of re-muting the video. */
      if (!v.muted) return;
      toggleMute();
    });
  }

  /* Info modal (e.g. the formula-update note) — centered overlay opened from
     the chip on a video; closes via × / Esc / clicking the backdrop. */
  function openModal(m) {
    window.fizzyPopupMotion.reveal(m, function () {
      m.hidden = false; document.body.style.overflow = 'hidden';
    });
  }
  function closeModal(m) {
    window.fizzyPopupMotion.dismiss(m, function () {
      m.hidden = true; document.body.style.overflow = '';
    });
  }
  function closeAllModals() {
    document.querySelectorAll('[data-ffv-info-modal]:not([hidden])').forEach(closeModal);
  }

  function bootInfoModals() {
    document.querySelectorAll('[data-ffv-info-open]').forEach(function (btn) {
      /* The trigger may live inside a video col, or stand alone above the
         accordion — fall back to a sibling, then the only modal on the page. */
      var col = btn.closest('.ffv-col') || btn.parentNode;
      var pop = (col && col.querySelector('[data-ffv-info-modal]')) || document.querySelector('[data-ffv-info-modal]');
      if (!pop) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        openModal(pop);
      });
      /* Click outside the dialog (i.e. on the backdrop) closes. */
      pop.addEventListener('click', function (e) {
        if (!e.target.closest('.ffv-pop-dialog')) closeModal(pop);
      });
      pop.querySelectorAll('[data-ffv-info-close]').forEach(function (c) {
        c.addEventListener('click', function (e) { e.stopPropagation(); closeModal(pop); });
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllModals(); });
  }

  function boot() {
    document.querySelectorAll('.ffv-card.has-video').forEach(bootCard);
    bootInfoModals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
